//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.0.7.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { localeStore } from '@/store/locale';import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';

export class BffClientBase {
  constructor() {
  }

  protected transformOptions(options: AxiosRequestConfig) {
    options.headers['Accept-Language'] = localeStore().locale
    return Promise.resolve(options)
  }

  protected transformResult(url: string, response: AxiosResponse<any>, processor: (response: AxiosResponse<any>) => any) {
    const contentType = response.headers['content-type'] as string
    if (contentType && contentType.indexOf('text/html') >= 0) {
      const loc = `${location.protocol}//${location.hostname}:${location.port}`
      if (response.request.responseURL.indexOf(loc) < 0) {
        const unauthorizedError = {
          status: 401,
          statusText: response.request.responseURL,
        }
        throw unauthorizedError
      }
    }
    return processor(response)
  }
}

export interface IGezinClient {
    /**
     * @return OK
     */
    geefKindVoordelen_GeefKindVoordelen(request: GeefKindVoordelenRequest): Promise<GeefKindVoordelenResponse>;
    /**
     * @param csv (optional) 
     * @return OK
     */
    geefKindVoordelen_ValidateKindvoordelenBulk(csv?: FileParameter | null | undefined): Promise<ValidateKindvoordelenBulkResponse>;
    /**
     * @return OK
     */
    geefKindVoordelen_GeefKindvoordelenBulk(request: GeefKindvoordelenBulkRequest): Promise<GeefKindvoordelenBulkResponse>;
    /**
     * @param count (optional) 
     * @return OK
     */
    geefKindVoordelen_GeefKindvoordelenBulkResultaat(jobId: string, count?: number | undefined): Promise<FileResponse>;
    buildInfo_Index(): Promise<FileResponse>;
}

export class GezinClient extends BffClientBase implements IGezinClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        super();

        this.instance = instance || axios.create();

        this.baseUrl = baseUrl ?? "https://localhost:48882";

    }

    /**
     * @return OK
     */
    geefKindVoordelen_GeefKindVoordelen(request: GeefKindVoordelenRequest, cancelToken?: CancelToken): Promise<GeefKindVoordelenResponse> {
        let url_ = this.baseUrl + "/api/v1/geefkindvoordelen";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGeefKindVoordelen_GeefKindVoordelen(_response));
        });
    }

    protected processGeefKindVoordelen_GeefKindVoordelen(response: AxiosResponse): Promise<GeefKindVoordelenResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<GeefKindVoordelenResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400;
            return throwException("Validation errors.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = resultData404;
            return throwException("Not found.", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = resultData401;
            return throwException("Not authorized to perform the operation.", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = resultData500;
            return throwException("Unexpected error.", status, _responseText, _headers, result500);

        } else if (status === 502) {
            const _responseText = response.data;
            let result502: any = null;
            let resultData502  = _responseText;
            result502 = resultData502;
            return throwException("Bad gateway error.", status, _responseText, _headers, result502);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = resultData403;
            return throwException("Insufficient permissions to perform the operation.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GeefKindVoordelenResponse>(null as any);
    }

    /**
     * @param csv (optional) 
     * @return OK
     */
    geefKindVoordelen_ValidateKindvoordelenBulk(csv?: FileParameter | null | undefined, cancelToken?: CancelToken): Promise<ValidateKindvoordelenBulkResponse> {
        let url_ = this.baseUrl + "/api/v1/geefkindvoordelen/bulk/validate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (csv !== null && csv !== undefined)
            content_.append("csv", csv.data, csv.fileName ? csv.fileName : "csv");

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGeefKindVoordelen_ValidateKindvoordelenBulk(_response));
        });
    }

    protected processGeefKindVoordelen_ValidateKindvoordelenBulk(response: AxiosResponse): Promise<ValidateKindvoordelenBulkResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<ValidateKindvoordelenBulkResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400;
            return throwException("Validation errors.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = resultData404;
            return throwException("Not found.", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = resultData401;
            return throwException("Not authorized to perform the operation.", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = resultData500;
            return throwException("Unexpected error.", status, _responseText, _headers, result500);

        } else if (status === 502) {
            const _responseText = response.data;
            let result502: any = null;
            let resultData502  = _responseText;
            result502 = resultData502;
            return throwException("Bad gateway error.", status, _responseText, _headers, result502);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = resultData403;
            return throwException("Insufficient permissions to perform the operation.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ValidateKindvoordelenBulkResponse>(null as any);
    }

    /**
     * @return OK
     */
    geefKindVoordelen_GeefKindvoordelenBulk(request: GeefKindvoordelenBulkRequest, cancelToken?: CancelToken): Promise<GeefKindvoordelenBulkResponse> {
        let url_ = this.baseUrl + "/api/v1/geefkindvoordelen/bulk";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(request);

        let options_: AxiosRequestConfig = {
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGeefKindVoordelen_GeefKindvoordelenBulk(_response));
        });
    }

    protected processGeefKindVoordelen_GeefKindvoordelenBulk(response: AxiosResponse): Promise<GeefKindvoordelenBulkResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = resultData200;
            return Promise.resolve<GeefKindvoordelenBulkResponse>(result200);

        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400;
            return throwException("Validation errors.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = resultData404;
            return throwException("Not found.", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = resultData401;
            return throwException("Not authorized to perform the operation.", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = resultData500;
            return throwException("Unexpected error.", status, _responseText, _headers, result500);

        } else if (status === 502) {
            const _responseText = response.data;
            let result502: any = null;
            let resultData502  = _responseText;
            result502 = resultData502;
            return throwException("Bad gateway error.", status, _responseText, _headers, result502);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = resultData403;
            return throwException("Insufficient permissions to perform the operation.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GeefKindvoordelenBulkResponse>(null as any);
    }

    /**
     * @param count (optional) 
     * @return OK
     */
    geefKindVoordelen_GeefKindvoordelenBulkResultaat(jobId: string, count?: number | undefined, cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/api/v1/geefkindvoordelen/bulk/{jobId}?";
        if (jobId === undefined || jobId === null)
            throw new Error("The parameter 'jobId' must be defined.");
        url_ = url_.replace("{jobId}", encodeURIComponent("" + jobId));
        if (count === null)
            throw new Error("The parameter 'count' cannot be null.");
        else if (count !== undefined)
            url_ += "count=" + encodeURIComponent("" + count) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processGeefKindVoordelen_GeefKindvoordelenBulkResultaat(_response));
        });
    }

    protected processGeefKindVoordelen_GeefKindvoordelenBulkResultaat(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data]), headers: _headers });
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = resultData400;
            return throwException("Validation errors.", status, _responseText, _headers, result400);

        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = resultData404;
            return throwException("Not found.", status, _responseText, _headers, result404);

        } else if (status === 401) {
            const _responseText = response.data;
            let result401: any = null;
            let resultData401  = _responseText;
            result401 = resultData401;
            return throwException("Not authorized to perform the operation.", status, _responseText, _headers, result401);

        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = resultData500;
            return throwException("Unexpected error.", status, _responseText, _headers, result500);

        } else if (status === 502) {
            const _responseText = response.data;
            let result502: any = null;
            let resultData502  = _responseText;
            result502 = resultData502;
            return throwException("Bad gateway error.", status, _responseText, _headers, result502);

        } else if (status === 403) {
            const _responseText = response.data;
            let result403: any = null;
            let resultData403  = _responseText;
            result403 = resultData403;
            return throwException("Insufficient permissions to perform the operation.", status, _responseText, _headers, result403);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }

    buildInfo_Index( cancelToken?: CancelToken): Promise<FileResponse> {
        let url_ = this.baseUrl + "/buildinfo";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            responseType: "blob",
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/octet-stream"
            },
            cancelToken
        };

        return this.transformOptions(options_).then(transformedOptions_ => {
            return this.instance.request(transformedOptions_);
        }).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.transformResult(url_, _response, (_response: AxiosResponse) => this.processBuildInfo_Index(_response));
        });
    }

    protected processBuildInfo_Index(response: AxiosResponse): Promise<FileResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers["content-disposition"] : undefined;
            const fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
            const fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            return Promise.resolve({ fileName: fileName, status: status, data: new Blob([response.data]), headers: _headers });
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FileResponse>(null as any);
    }
}

export interface GeefKindVoordelenResponse {
    kindVoordelen?: GeefKindVoordelenDto[];
    waarschuwingen?: MagdaError[];
}

export interface GeefKindVoordelenDto {
    bron?: string;
    insz?: string;
    kindVoordeelFonds?: KindVoordeelFondsDto;
    dossiernummer?: string;
    rechthebbende?: string;
    begunstigden?: KindVoordeelBegunstigdeDto[];
    kinderen?: KindVoordeelKindDto[];
}

export interface KindVoordeelFondsDto {
    item?: string;
    type?: FondsTypeEnum;
    omschrijving?: string;
}

export enum FondsTypeEnum {
    Code = "Code",
    Ondernemingsnummer = "Ondernemingsnummer",
}

export interface KindVoordeelBegunstigdeDto {
    insz?: string;
    bonussen?: KindVoordeelBonusDto[];
    betalingsperiodes?: KindVoordeelBetalingsperiodeDto[];
}

export interface KindVoordeelBonusDto {
    betalingsdatum?: string;
    categorie?: KindVoordeelBonusCategorieDto;
}

export interface KindVoordeelOmschrijvingDto {
    code?: string;
    omschrijving?: string;
}

export interface KindVoordeelBonusCategorieDto extends KindVoordeelOmschrijvingDto {
}

export interface KindVoordeelBetalingsperiodeDto {
    periode?: PeriodeDto;
    categorie?: KindVoordeelBetalingsperiodeCategorieDto;
}

export interface PeriodeDto {
    beginMaand?: string;
    eindMaand?: string;
}

export interface KindVoordeelBetalingsperiodeCategorieDto extends KindVoordeelOmschrijvingDto {
}

export interface KindVoordeelKindDto {
    insz?: string;
    bonussen?: KindVoordeelKindBonusDto[];
    betalingsperiodes?: KindVoordeelKindBetalingsperiodeDto[];
}

export interface KindVoordeelKindBonusDto extends KindVoordeelBonusDto {
    begunstigden?: string[];
}

export interface KindVoordeelKindBetalingsperiodeDto extends KindVoordeelBetalingsperiodeDto {
    begunstigden?: string[];
}

export interface MagdaError {
    message: string | undefined;
    description?: string | undefined;
    externalCode?: string | undefined;
    type?: MagdaErrorType;
}

export enum MagdaErrorType {
    Error = "Error",
    Warning = "Warning",
    Information = "Information",
}

export interface ErrorMessage {
    type?: string | undefined;
    title: string;
    status?: number;
    detail: string;
    instance?: string | undefined;
}

export interface GeefKindVoordelenRequest {
    insz?: string;
    from?: Date;
    until?: Date;
    betalingsperiodeCategories?: FilterBetalingsperiodeEnum[];
    typeSociaal?: TypeSociaalInvoegenEnum | undefined;
}

export enum FilterBetalingsperiodeEnum {
    BASIS = "BASIS",
    KINDEROPVANG = "KINDEROPVANG",
    KLEUTER = "KLEUTER",
    ONDERSTEUNINGSTOESLAG = "ONDERSTEUNINGSTOESLAG",
    PARTICIPATIE_SELECTIEF = "PARTICIPATIE_SELECTIEF",
    PARTICIPATIE_UNIVERSEEL = "PARTICIPATIE_UNIVERSEEL",
    ZORG_PLEEG = "ZORG_PLEEG",
    ZORG_SPECIALE_NODEN = "ZORG_SPECIALE_NODEN",
    ZORG_WEES = "ZORG_WEES",
}

export enum TypeSociaalInvoegenEnum {
    MET_TYPE_SOCIAAL = "MET_TYPE_SOCIAAL",
    ZONDER_TYPE_SOCIAAL = "ZONDER_TYPE_SOCIAAL",
}

export interface ValidateKindvoordelenBulkResponse {
    validated?: string[];
    errors?: string[];
}

export interface GeefKindvoordelenBulkResponse {
    jobId?: string;
}

export interface GeefKindvoordelenBulkRequest {
    insz?: string[];
    from?: Date;
    until?: Date;
    betalingsperiodeCategories?: FilterBetalingsperiodeEnum[];
    typeSociaal?: TypeSociaalInvoegenEnum | undefined;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    throw new ApiException(message, status, response, headers, result);
}

function isAxiosError(obj: any): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}